import { FC, useContext } from 'react';

import { useContent } from '@eneco/cms';
import { typedYupResolver } from '@eneco/hooks/form';
import { Button, Form, Heading, Stack, Text, NavLink, InputPassword } from '@eneco/sparky';
import { ChevronLeftIcon } from '@eneco/sparky/icons';
import { SubmitHandler, useForm } from 'react-hook-form';


import { RegistrationAccountContent } from '../registrationFlow.types';
import { registerOrgPasswordSchema } from './registerOrgPasswordSchema';
import { Action, State } from '../registrationFlow.constants';
import { RegistrationMachine } from '../registrationFlow.machine';

const resolver = typedYupResolver<FormValues>(registerOrgPasswordSchema);

type FormValues = {
  password: string;
};

export const RegisterOrgPassword: FC = () => {
  const content = useContent<RegistrationAccountContent>();
  const { send, state } = useContext(RegistrationMachine);
  const isSettingNewCredentials = state.value === State.SETTING_NEW_CREDENTIALS;
  const {
    formState: { errors },
    handleSubmit,
    register,
  } = useForm<FormValues>({
    resolver,
  });
  const handleBack = () => send({ type: Action.BACK });

  const submitForm: SubmitHandler<FormValues> = ({ password }) => {
    send({ type: Action.CUSTOMER_SET_PASSWORD, password });
  };

  const formErrorMessages: { [key: string]: string } = {
    passwordInvalid: content.RegisterOrgPassword_passwordFormField?.validationMessage ?? '',
    passwordRequired: content.RegisterOrgPassword_passwordFormField?.requiredMessage ?? '',
  };

  return (
    <Form onSubmit={handleSubmit(submitForm)}>
      <Stack gap="6">
        <NavLink variant="secondary" onClick={handleBack} leftIcon={<ChevronLeftIcon />}>
          E-mailadres
        </NavLink>
        <Heading as="h1" size="XS">
          {content.RegisterOrgPassword_title}
        </Heading>
        <Text>{content.RegisterOrgPassword_introductionText}</Text>
        <InputPassword
          {...register('password')}
          label={content.RegisterOrgPassword_passwordFormField?.label ?? ''}
          autoComplete="new-password"
          hint={content.RegisterOrgPassword_passwordFormField?.hint}
          error={errors?.password?.message && formErrorMessages[errors.password.message]}
          isReadOnly={isSettingNewCredentials}
        />
        <Button type="submit" isLoading={isSettingNewCredentials}>
          {content.RegisterOrgPassword_confirmButtonText}
        </Button>
      </Stack>
    </Form>
  );
};
